
/**************************************************************************
 * File: application.ts
 * Notes: Extended application functions
 **************************************************************************/
import actions from './actions'
import UiState from './models/ui-state'
import { getPropertyValue, createHtmlProperty } from './response-helper'

const API = Mindbreeze['require']('api/v2/api');
const BaseApplication = Mindbreeze['require']('client/application');
const $ = Mindbreeze['require']('jquery');


const Application = BaseApplication
  .extend(actions)
  .extend({

    fetchPreviewContent: function (
        origin: any,
        location: any,
        category: any,
        categoryinstance: any
      ) {

          return fetch(
            `${window.location.origin}/search/api/v2/preview`,
            // `https://nyc-dev.mindbreeze.com/search/api/v2/preview`, // For VM testing only
            {
              method: "POST",
              body: JSON.stringify({
                location: location,
                category: category,
                categoryinstance: categoryinstance,
                query_expr: { and: [{ unparsed: "", id: "query" }] },
                full_html: true,
                properties: [
                  { formats: ["HTML"], name: "title" },
                  { formats: ["PROPERTY"], name: "mes:summary" },
                  { formats: ["HTML"], name: "content" },
                  { formats: ["HTML"], name: "extension" },
                  { formats: ["HTML"], name: "html/head" },
                  { formats: ["HTML"], name: "categoryclass" },
                  { formats: ["HTML"], name: "@content" },
                  {
                    formats: ["HTML"],
                    name: "i18n.document-not-found",
                  },
                  { formats: ["HTML"], name: "icon" },
                  { formats: ["HTML"], name: "i18n.date" },
                  { formats: ["PROPERTY"], name: "mes:date" },
                ],
                user_context: {
                  referer:
                    origin + "/search/apps/summary-demo/",
                    //"https://nyc-dev.mindbreeze.com" + "/search/apps/summary-demo/", // For VM testing only
                  locale: "en-US",
                  service_id:
                    origin + "/search/apps/scripts/../scripts/../../api/v2/",
                    //"https://nyc-dev.mindbreeze.com" + "/search/apps/scripts/../scripts/../../api/v2/", // For VM testing only
                  utc_time_zone_differential_in_seconds: 3600,
                  service_url:
                    origin + "/search/apps/scripts/../../api/v2/preview" ,
                    //"https://nyc-dev.mindbreeze.com" + "/search/apps/scripts/../../api/v2/preview" , // For VM testing only
                },
              }),
              credentials: "include",
              headers: {
                "Content-type": "application/json; charset=UTF-8",
              },
            }
          )
            .then((response: { text: () => any }) => response.text())
            .then((body: string) => {
              return JSON.parse(body).result.properties[3].data[0].html;
            });
      },

      /*summarizeDocument: async function () {
        this.models.search.set("constraint", {
          and: [
            {
              label: "fqcategory",
              quoted_term:
                this.options.resultModel.get("category", {
                  format: "VALUE",
                }) +
                ":" +
                this.options.resultModel.get("categoryinstance", {
                  format: "VALUE",
                }),
            },
            {
              label: "mes:key",
              quoted_term: this.options.resultModel.get("mes:key", {
                format: "VALUE",
              }),
            },
          ],
        });
        const keys = this.options.resultModel.get("mes:key", {
          format: "VALUE",
        });
        const keysElement = document.getElementById("meskey");
        if (keysElement) {
          keysElement.innerHTML = keys;
        }
      },

      summarize: async function (options: any) {
        
        const content = await this.fetchPreviewContent(
          window.location.origin,
          options.model.get("location", { format: "VALUE" }),
          options.model.get("category", { format: "VALUE" }),
          options.model.get("categoryinstance", { format: "VALUE" })
        ).then((response: any) => {
          return response;
        });
        
        const llmModelElement = document.getElementById("LLMmodel");
        if (llmModelElement) {
          llmModelElement.innerHTML =
            "0e92cb9d-edce-4dce-957a-d7420c903ee6"; // LLM ID
        }
        const llmModelNameElement =
          document.getElementById("LLMmodelName");
        if (llmModelNameElement) {
          llmModelNameElement.innerHTML = "mindbreeze llm"; //llm model for feedback
        }
        const summarizePromptElement =
          document.getElementById("summarizePrompt");
        if (summarizePromptElement) {
          summarizePromptElement.setAttribute(
            "data-prompt-user-message-template",
            content
          );
        }
         this.pushStack({
          title:
            "Document summary of: " +
            options.model.get("title", { format: "VALUE" }),
          "template-ref": "summaryTemplate",
          action: "summarizeDocument",
          applicationOptions: {
            startSearch: false,
            resultModel: options.model,
          },
        });
      },

      draftDecisionDocument: async function () {
        this.models.search.set("constraint", {
          and: [
            {
              label: "fqcategory",
              quoted_term:
                this.options.resultModel.get("category", {
                  format: "VALUE",
                }) +
                ":" +
                this.options.resultModel.get("categoryinstance", {
                  format: "VALUE",
                }),
            },
            {
              label: "mes:key",
              quoted_term: this.options.resultModel.get("mes:key", {
                format: "VALUE",
              }),
            },
          ],
        });
        const keys = this.options.resultModel.get("mes:key", {
          format: "VALUE",
        });
        const keysElement = document.getElementById("meskey");
        if (keysElement) {
          keysElement.innerHTML = keys;
        }
      },

      draftDecision: async function (options: any) {
        
        const content = await this.fetchPreviewContent(
          window.location.origin,
          options.model.get("location", { format: "VALUE" }),
          options.model.get("category", { format: "VALUE" }),
          options.model.get("categoryinstance", { format: "VALUE" })
        ).then((response: any) => {
          return response;
        });
        
        const llmModelElement = document.getElementById("LLMmodel");
        if (llmModelElement) {
          llmModelElement.innerHTML =
            "0e92cb9d-edce-4dce-957a-d7420c903ee6"; // LLM ID
        }
        const llmModelNameElement =
          document.getElementById("LLMmodelName");
        if (llmModelNameElement) {
          llmModelNameElement.innerHTML = "mindbreeze llm"; //llm model for feedback
        }
        const draftDecisionPromptElement =
          document.getElementById("draftDecisionPrompt");
        if (draftDecisionPromptElement) {
          draftDecisionPromptElement.setAttribute(
            "data-prompt-user-message-template",
            content
          );
        }
         this.pushStack({
          title:
            "Decision draft of: " +
            options.model.get("title", { format: "VALUE" }),
          "template-ref": "decisionTemplate",
          action: "draftDecisionDocument",
          applicationOptions: {
            startSearch: false,
            resultModel: options.model,
          },
        });
      },*/
      
    /*************************************************************************
   * Name: createModels
   * Params: 
   * Purpose: Called before the first views/widgets are initialized and
   *          when the app is initialized
   *************************************************************************/
    createModels: function () {
        this.listenTo(this, "all", function(){console.log('all log', arguments)})
        this.createUiStateModel();
    },

    /*************************************************************************
   * Name: prepareModels
   * Params: 
   * Purpose: Called when the application is initializing and create models
   *          has been called
   *************************************************************************/
    prepareModels: function () {
        this.prepareSearchModel();
        this.connectModels();

        //called on each results to build and add download actions
        const addCustomActionsTransformer = function (responseData) {
          return new Promise((resolve) => {
              responseData.resultset.results.forEach((result) => {
                  const downloadAction = buildDownloadAction(result);
                  if (downloadAction)
                      addAction(result, downloadAction);
      
                  const shareAction = buildShareAction(result);
                  if (shareAction)
                      addAction(result, shareAction);
              });
      
              resolve();
          });
      };
      
      this.models.search.output.loadTransformers.push(
          addCustomActionsTransformer,
      );

      //builds download action
      function buildDownloadAction(result) {
        const title = result.properties.find((el) => el.id == "title")
          .properties[0].data[0].value.str;
        var current_location = null;

        if (
          result?.properties
            ?.find((el) => el.id == "actions")
            ?.properties.find((el) => el.id == "Preview")?.data[0]?.value.action
            ?.preview?.content_location
        ) {
          current_location =
          new URL(
            result.properties
              ?.find((el) => el.id == "actions")
              .properties.find((el) => el.id == "Preview").data[0].value.action
              .preview.content_location,
          ) || new URL();
        current_location.pathname = "/search/content";
        } else {
          return null;
        }

        return {
          id: "Download",
          name: "Download",
          data: [
            {
              html: `<a tabindex="0" role="button" data-action="downloadDocument('${current_location}', '${title}')">Download</a>`,
              value: {
                href: current_location,
                rel: "action",
              },
              actionId: "Download",
            },
          ],
        };
      };

      // builds Share action
    function buildShareAction(result) {
      const contentLocation =
          result?.properties
              ?.find((el) => el.id === "actions")
              ?.properties
              ?.find((el) => el.id === "Preview")
              ?.data?.[0]
              ?.value
              ?.action
              ?.preview
              ?.content_location;

      if (!contentLocation) {
          return null;
      }

      // Encode the URL before putting it into the HTML/JavaScript attribute.
      const encodedLocation = encodeURIComponent(contentLocation);

      return {
          id: "Share",
          name: "Share",
          data: [
              {
                  html: `<a tabindex="0" role="button" onclick="shareDocument('${encodedLocation}', this); return false;">Share</a>`,
                  value: {
                      href: contentLocation,
                      rel: "action",
                  },
                  actionId: "Share",
              },
          ],
      };
    }
      

      //adds action to result
      function addAction(result, action) {
        if (!result.properties?.find((el) => el.id == "actions")) return false;
        result.properties
          ?.find((el) => el.id == "actions")
          .properties.push(action);
      };
    },

    createUiStateModel: function () {
        this.models.uiState = new UiState();
    },

    prepareSearchModel: function () {
        this.listenTo(API.search, 'loadoutput', this.beforeSearchModelOutputUpdate);
        // this.listenTo(this.models.search, 'computed', this.doSomethingWhenResultsAreAvailable);
    },

    connectModels: function () {
        //this.listenTo(this.models.uiState, 'change:language', this.updateLanguage);
    },

    beforeSearchModelOutputUpdate: function  (model, atts, options) {
        if (model === this.models.search.output) {
            const results = atts?.resultset?.results || atts?.results;

            try{
                
                this.customizeSortSwitch(model, atts, options);
            } catch (error)
            {
                console.log('Customize Switch Error', error)
            }

            if (results) {
                results.forEach(result => {
                    this.addGeneratedProperty(result);
                })
            }
        }
    },

    addGeneratedProperty: function (result) {
        const key = getPropertyValue(result, 'mes:key');
        result.properties['generatedProperty'] = createHtmlProperty('generatedProperty', key);
    },

    /*************************************************************
     * Name: customizeSortSwitch
     * Purpose: Update sthe sort switch widget for customer needs
     * Params: model
     *         atts
     *         options
     *************************************************************/
    customizeSortSwitch: function (model, atts, options) {

        const orderable = [
            {
                name: 'mes:relevance',
                localized_name: 'Relevance'
            },
            {
                name: 'mes:date',
                localized_name: "Decision Date"
            }
        ];
        atts.orderable = orderable;
    }
  });

  Application.launch = () => {
    window.app = new Application({
        initializeModels: (app) => app.createModels(),
    });

    // close welcome modal if user clicks outside of modal content
    window.onclick = function (event) {
        if (event.target.id == 'welcomeModal')
            this.app.closeWelcomeModal();
    };

    // download function
    window.downloadDocument = async function (url, title) {
        try {
            const response = await fetch(url, {
                credentials: "include",
            });

            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = title + ".pdf";
            a.click();

            URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error(
                "Error downloading document:",
                error.message
            );
        }
    };

    // share function
    window.shareDocument = async function (encodedUrl, clickedElement) {
      const url = decodeURIComponent(encodedUrl);
  
      try {
          await navigator.clipboard.writeText(url);
  
          showShareNotification(
              "Link copied to clipboard!",
              clickedElement
          );
      } catch (error) {
          console.error("Error copying link to clipboard:", error);
  
          showShareNotification(
              "Unable to copy the link. Please copy it manually.",
              clickedElement
          );
      }
  };

    // share notification
    function showShareNotification(message, clickedElement) {
      let notification = document.getElementById("shareNotification");
  
      if (!notification) {
          notification = document.createElement("div");
          notification.id = "shareNotification";
  
          notification.style.position = "fixed";
          notification.style.zIndex = "9999";
          notification.style.padding = "8px 14px";
          notification.style.backgroundColor = "#333";
          notification.style.color = "#fff";
          notification.style.borderRadius = "4px";
          notification.style.boxShadow = "0 2px 8px rgba(0,0,0,0.25)";
          notification.style.fontSize = "14px";
          notification.style.transition = "opacity 0.3s ease";
  
          document.body.appendChild(notification);
      }
  
      notification.textContent = message;
  
      const rect = clickedElement.getBoundingClientRect();
  
      notification.style.left = `${rect.left}px`;
      notification.style.top = `${rect.bottom + 8}px`;
  
      notification.style.opacity = "1";
  
      clearTimeout(notification.hideTimeout);
  
      notification.hideTimeout = setTimeout(() => {
          notification.style.opacity = "0";
      }, 2000);
  }
};

export default Application;